
export const steps = ["Received", "Preparing", "Shipped", "Delivered"] as const

export type ParcelStatusKey =
  | "received"
  | "preparing"
  | "shipped"
  | "delivered"
  | "canceled"

const STEP_KEYS: Exclude<ParcelStatusKey, "canceled">[] = [
  "received",
  "preparing",
  "shipped",
  "delivered",
]

export const isParcelCanceled = (orderStatus?: string | null) =>
  orderStatus === "canceled"

export const parcelStatuses = (fulfillmentStatus?: string | null) => {
  switch (fulfillmentStatus) {
    case "not_fulfilled":
      return 0
    case "fulfilled":
    case "partially_fulfilled":
      return 1
    case "delivered":
    case "partially_delivered":
      return 3
    case "shipped":
    case "partially_shipped":
      return 2
    default:
      return 0
  }
}

/** Stable key for i18n: parcel_status.{key} */
export const getParcelStatusKey = (
  orderStatus?: string | null,
  fulfillmentStatus?: string | null
): ParcelStatusKey => {
  if (isParcelCanceled(orderStatus)) {
    return "canceled"
  }
  return STEP_KEYS[parcelStatuses(fulfillmentStatus)]
}

/** English fallback label (progress bar / legacy). Prefer getParcelStatusKey + t(). */
export const getParcelStatusLabel = (
  orderStatus?: string | null,
  fulfillmentStatus?: string | null
) => {
  const key = getParcelStatusKey(orderStatus, fulfillmentStatus)
  if (key === "canceled") return "Canceled"
  return steps[STEP_KEYS.indexOf(key)]
}
